import React from 'react';
import { RiMapPinLine } from 'react-icons/ri';
import Card from '@/components/ui/cards/Card';

export default function AddressTab() {
  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      <div className="flex items-center gap-2 mb-4">
        <RiMapPinLine className="text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Address</h3>
      </div>
      <div className="text-center text-gray-500 p-6">
        No addresses available.
      </div>
    </Card>
  );
}
